import { Component } from "@angular/core";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { filter, finalize } from 'rxjs/operators';
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { PageBase } from "../page.base";
import JsonHelper from "../../utils/json-helper";
import { CheckPaymentResponse } from "../../dtos/check-payment.response.dto";
import { RefundRequest } from "../../dtos/refund.request.dto";
import { SubscriberInfoResponse } from "../../dtos/subscriber-info.response.dto";
import { RefundResponse } from "../../dtos/refund.response.dto";


@Component({
    standalone: false,
    selector: 'refund-page',
    templateUrl: './refund-page.component.html',
    styleUrls: ['./refund-page.component.scss']
})

export class RefundPageComponent extends PageBase {
    form: FormGroup = this.fb.group({
        email: new FormControl(null, [Validators.required, Validators.email]),
        invoiceNumber: new FormControl(null, [Validators.required]),
        transactionId: new FormControl(null, [Validators.required]),
    })

    formSettings = {
        email: { maxLength: 60 },
        invoiceNumber: { maxLength: 20 },
        transactionId: { maxLength: 40 }
    };

    subscriberInfo: SubscriberInfoResponse;
    activePageId: number = 0;
    invoiceRequest?: RefundRequest;
    orderedItems?: CheckPaymentResponse;
    cancelOrderSuccess: boolean = false;
    refundObject?: RefundResponse;

    constructor() {
        super();

        this.route.queryParams
            .pipe(filter((p: any) => p.Subscriber))
            .subscribe(params => {
                const dataKey = Object.keys(params).find(k => k.toLowerCase() === "data");
                if (dataKey) {
                    const base64EncodedRefundData = params[dataKey];
                    const bytes = Uint8Array.from(atob(base64EncodedRefundData), c => c.charCodeAt(0));
                    const json = new TextDecoder().decode(bytes);

                    const refundData = JsonHelper.Deserialize(json);

                    // form felt�lt�se a visszafejtett adatokkal
                    this.form.patchValue(refundData);
                }
            });

        this.showSpinnerWithDelay();
        this.appInit.whenReady()
            .pipe(takeUntilDestroyed(this.destroyRef), finalize(() => this.hideSpinner()))
            .subscribe({
                next: () => this.subscriberInfo = this.appInit.initData?.subscriber
            });
    }

    getItemList() {
        this.invoiceRequest = {
            email: this.form.value.email,
            invoiceNumber: this.form.value.invoiceNumber,
            transactionId: this.form.value.transactionId
        };

        this.showSpinnerWithDelay();
        this.shopService.checkRefund(this.invoiceRequest)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                finalize(() => {
                    this.hideSpinner();
                })
            )
            .subscribe({
                next: (response: CheckPaymentResponse) => {
                    this.activePageId = 1;
                    this.orderedItems = response;
                },
                error: (err) => this.errorService.showError(err)
            })
    }

    backToInvoiceData() {
        this.activePageId = 0;
    }

    async refund() {
        const result = await this.dialogService.openYesNoDialog(
            this.translateService.instant("refund.cancalOrder_question"),
            this.translateService.instant("common.yes"),
            this.translateService.instant("common.no"));
        if (result) {
            this.showSpinnerWithDelay();
            this.shopService.refund(this.invoiceRequest)
                .pipe(
                    takeUntilDestroyed(this.destroyRef),
                    finalize(() => {
                        this.hideSpinner();
                        this.activePageId = 2;
                    })
                )
                .subscribe({
                    next: (response: RefundResponse) => {
                        this.cancelOrderSuccess = true;
                        this.refundObject = response;
                    },
                    error: (err: any) => {
                        this.cancelOrderSuccess = false;
                        this.errorService.showError(err);
                    }
                })
        }
    }

    backToInvoiceItems() {
        this.activePageId = 1;
    }
}
